
/* tslint:disable:member-access */
import * as classNames from 'classnames';
import * as React from 'react';

import axios, { AxiosResponse } from 'axios';
import Exclamation from 'src/svgs/Exclamation.svg';

import styled from '@emotion/styled';

import { WaitFreeTimer } from './WaitFreeTimer';

declare var global: {
  Ridi: {
    globals: {
      isLoggedIn: boolean;
      isMobile: boolean;
    };
  };
};

// @ts-ignore
const StyledExclamation = styled(Exclamation)`margin-left: 5.25px`;

interface Props {
  bookId: number;
}

interface State {
  rentDays: number;
  rentVolume: number;
  intervalHours: number;
  unavailableRecentCount: number;
  availableMaxVolume?: number;
  availableAt?: string;
}

export class WaitFree extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  state: State = {
    rentDays: 0,
    rentVolume: 0,
    unavailableRecentCount: 0,
    intervalHours: 0,
    availableMaxVolume: null,
    availableAt: null,
  };

  // TODO: use redux store
  componentDidMount() {
    axios
      .get(`/api/wait-free/${this.props.bookId}`)
      .then(({ data }: AxiosResponse<{
        available_at: string;
        available_max_volume: number;
        interval_hours: number;
        rent_days: number;
        rent_volume: number;
        series_id: string;
        unavailable_recent_count: number;
      }>) => {
        this.setState({
          availableAt: data.available_at,
          rentDays: data.rent_days,
          rentVolume: data.rent_volume,
          unavailableRecentCount: data.unavailable_recent_count,
          intervalHours: data.interval_hours,
          availableMaxVolume: data.available_max_volume,
        });
        window.dispatchEvent(new CustomEvent('updateWaitFreePopupData', {
          detail: {
            rentDays: data.rent_days,
            rentVolume: data.rent_volume,
            unavailableRecentCount: data.unavailable_recent_count,
            availableMaxVolume: data.available_max_volume,
          },
        }));
      });
  }

  handleRemoveAvailableAt = () => {
    this.setState({ availableAt: null });
  }

  onClickWaitFreeHelp(interval: string) {
    const {
      rentDays,
      rentVolume,
      unavailableRecentCount,
    } = this.state;

    window.dispatchEvent(new CustomEvent('toggleWaitFreeHelpPopup', {
      detail: {
        interval,
        rentDays,
        rentVolume,
        unavailableRecentCount,
      },
    }));
  }

  renderIntervalText() {
    const {
      intervalHours,
    } = this.state;
    let dayCount = 0;
    const hourCount = intervalHours % 24;
    if (intervalHours / 24 > 0) {
      dayCount = Math.floor(intervalHours / 24);
    }
    return `${dayCount > 0 ? `${dayCount}일 ` : ''}${hourCount !== 0 ? `${hourCount}시간` : ''}`;
  }

  renderWaitFreeTimer() {
    const {
      intervalHours,
      availableAt,
    } = this.state;

    if (availableAt) {
      return (
        <WaitFreeTimer
          intervalHours={intervalHours}
          availableAt={availableAt}
          close={this.handleRemoveAvailableAt}
        />
      );
    }

    return null;
  }

  render() {
    const {
      rentVolume,
      intervalHours,
      availableAt,
    } = this.state;
    const { isLoggedIn, isMobile } = global.Ridi.globals;
    const interval = this.renderIntervalText();

    return intervalHours ? (
      <li>
        <div className={isMobile ? 'BookDetailWaitFree_Mobile' : 'BookDetailWaitFree'}>
        <div
          className={classNames(
            'BookDetailNotice_List_Header',
            `BookDetailNotice_List_Header-WaitFree`,
          )}
        >
          리다무
        </div>

        <div className="BookDetailWaitFree_Header">
          {interval}마다 {rentVolume}편 기다리면 무료
        </div>
        <button
          className="BookDetailWaitFree_GuideButton"
          onClick={() => this.onClickWaitFreeHelp(interval)}
        >
          <StyledExclamation />
        </button>
          {!availableAt && isLoggedIn && (<span className="BookDetailWaitFree_Available">무료 이용 가능</span>)}
        </div>
        {this.renderWaitFreeTimer()}
      </li>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./pages/bookDetail/components/WaitFree.tsx